import { useState, useRef } from "react";
import SocialLinks from "./components/SocialLinks";
import Loader from "./components/Loader";
import NewsletterForm from "./components/NewsletterForm";
import HeroVideo from "./components/HeroVideo";
import SideNav from "./components/SideNav";
import Snow from "./components/Snow";

const featuredTracks = [
  {
    number: "01",
    title: "NIGHT VISION",
    subtitle: "w/ Achilles",
    label: "ARMIND RECORDS",
    genre: "",
    streamUrl: "https://open.spotify.com/track/6IZK71pLx3Qk4S4ygEzvYM",
    streamLabel: "SPOTIFY",
    soundcloudUrl: "https://soundcloud.com/achillesmusic/achilles-wintersix-night",
  },
  {
    number: "02",
    title: "THE CITY",
    subtitle: "w/ Julian Gray",
    label: "RIDE RECORDINGS",
    genre: "",
    streamUrl: "https://open.spotify.com/track/1240ZrBM30qOK6munA9YV0",
    streamLabel: "SPOTIFY",
    soundcloudUrl: "https://soundcloud.com/juliangray/julian-gray-wintersix-the-city-1",
  },
  {
    number: "03",
    title: "RAIN",
    subtitle: "feat. Alisky",
    label: "MAU5TRAP",
    genre: "",
    streamUrl: "https://open.spotify.com/track/4uvVgk1avAYC77lkr1PgOw",
    streamLabel: "SPOTIFY",
    soundcloudUrl: "https://soundcloud.com/mau5trap/wintersix-rain-feat-alisky",
  },
  {
    number: "04",
    title: "SOFI NEEDS A LADDER",
    subtitle: "Wintersix Remix",
    label: "DEADMAU5",
    genre: "",
    streamUrl: "https://www.youtube.com/watch?v=ByL_s3sPMt4",
    streamLabel: "YOUTUBE",
    soundcloudUrl: "https://soundcloud.com/wintersix6",
  },
];

function App() {
  const [loading, setLoading] = useState(false);
  const appRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={appRef} className="app">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Snow />

          {/* Sits outside .content so the fixed rail is not clipped by any
              ancestor stacking/containing block. */}
          <SideNav />

          <div className="content" id="top">
            {/* ── HERO: full-bleed video ── */}
            <div className="hero">
              <HeroVideo />

              <div className="hero-footer">
                <SocialLinks />
              </div>
            </div>

            <div className="scroll-sections">

              {/* ── MUSIC ── */}
              <section className="section" id="music">
                <h2>MUSIC</h2>

                {/* Featured Tracks */}
                <div className="featured-tracks">
                  {featuredTracks.map((track) => (
                    <div key={track.number} className="track-card">
                      <div className="track-number">{track.number}</div>
                      <div className="track-info">
                        <h3 className="track-title">
                          {track.title}
                          {track.subtitle && (
                            <span className="track-subtitle"> {track.subtitle}</span>
                          )}
                        </h3>
                        <span className="track-genre">{track.label}  {track.genre}</span>
                      </div>
                      <div className="track-actions">
                        <a
                          href={track.streamUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="track-btn"
                        >
                          {track.streamLabel}
                        </a>
                        <a
                          href={track.soundcloudUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="track-btn"
                        >
                          SOUNDCLOUD
                        </a>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Platform row */}
                <div className="platform-links">
                  <a
                    href="https://open.spotify.com/artist/6sfRrE7BI5Dm3axuoRlUWq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="platform-link"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.669 11.538a.5.5 0 0 1-.686.165c-1.879-1.147-4.243-1.407-7.028-.77a.499.499 0 0 1-.222-.973c3.048-.696 5.662-.397 7.77.892a.5.5 0 0 1 .166.686m.979-2.178a.624.624 0 0 1-.858.205c-2.15-1.321-5.428-1.704-7.972-.932a.625.625 0 0 1-.362-1.194c2.905-.881 6.517-.454 8.986 1.063a.624.624 0 0 1 .206.858m.084-2.268C10.154 5.56 5.9 5.419 3.438 6.166a.748.748 0 1 1-.434-1.432c2.825-.857 7.523-.692 10.492 1.07a.747.747 0 1 1-.764 1.288" />
                    </svg>
                    SPOTIFY
                  </a>
                  <a
                    href="https://soundcloud.com/wintersix6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="platform-link"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <g>
                        <path d="M13.51,7.26c-.18,0-.36.04-.55.08-.2-.95-.79-1.76-1.62-2.25-.53-.32-1.13-.49-1.74-.49-1.01,0-1.48.32-1.48.32-.18.06-.28.24-.28.45v5.56c0,.22.18.42.42.42h5.18c1.13.02,2.08-.87,2.14-2v-.04c0-1.15-.95-2.06-2.08-2.06Z" />
                        <path d="M7.05,5.54c-.08,0-.18.06-.18.14v.04c-.14,1.88-.24,3.62,0,5.48,0,.1.1.16.18.14.08,0,.14-.06.14-.14.26-1.88.16-3.6,0-5.48,0-.1-.06-.18-.14-.18Z" />
                        <path d="M5.96,6.21c-.08,0-.14.08-.16.16-.18,1.62-.18,3.24,0,4.86,0,.1.1.16.2.14.08,0,.14-.08.14-.14.2-1.6.21-3.24.01-4.86,0-.1-.09-.16-.19-.16Z" />
                        <path d="M4.93,6.07c-.08,0-.14.08-.14.14-.16,1.7-.24,3.3,0,5,0,.1.08.16.16.16.1,0,.16-.08.16-.16.24-1.72.18-3.28,0-5,0-.1-.1-.16-.18-.14Z" />
                        <path d="M3.88,6.51c-.1,0-.18.08-.18.18-.2,1.5-.2,3.01,0,4.53,0,.1.1.16.18.16s.14-.08.16-.16c.2-1.5.21-3.01.01-4.53,0-.1-.07-.18-.17-.18Z" />
                        <path d="M2.82,7.67c-.1,0-.16.08-.16.16-.24,1.17-.12,2.23,0,3.4,0,.08.1.14.18.14.06,0,.12-.06.14-.14.16-1.19.29-2.23.01-3.4,0-.1-.07-.16-.17-.16Z" />
                        <path d="M1.75,7.48c-.08,0-.14.08-.16.16-.22,1.19-.14,2.25,0,3.42,0,.18.32.18.34,0,.16-1.21.25-2.23.01-3.42,0-.1-.09-.16-.19-.16Z" />
                        <path d="M.7,8.07c-.08,0-.14.08-.16.16-.2.81-.14,1.46,0,2.27,0,.1.1.16.18.14.08,0,.14-.06.14-.14.18-.81.28-1.46.02-2.27,0-.1-.08-.16-.18-.16Z" />
                      </g>
                    </svg>
                    SOUNDCLOUD
                  </a>
                  <a
                    href="https://www.youtube.com/@wintersix"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="platform-link"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                      <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                    </svg>
                    YOUTUBE
                  </a>
                </div>

                {/* Spotify embed */}
                <div className="music-embed">
                  <iframe
                    src="https://open.spotify.com/embed/artist/6sfRrE7BI5Dm3axuoRlUWq"
                    width="100%"
                    height="380"
                    frameBorder="0"
                    allow="encrypted-media"
                    title="Wintersix music"
                  />
                </div>
              </section>

              {/* ── SOCIALS ── */}
              <section className="section" id="socials">
                <h2>SOCIALS</h2>
                <div className="social-links-expanded">
                  <div className="social-item">
                    <a href="https://x.com/wintersix6" target="_blank" rel="noopener noreferrer" className="social-platform-link">
                      <div className="social-icon-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="custom-svg">
                          <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                        </svg>
                      </div>
                      <div className="social-info"><h3>X (Twitter)</h3></div>
                    </a>
                  </div>

                  <div className="social-item">
                    <a href="https://www.facebook.com/wintersix6" target="_blank" rel="noopener noreferrer" className="social-platform-link">
                      <div className="social-icon-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="custom-svg">
                          <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                        </svg>
                      </div>
                      <div className="social-info"><h3>Facebook</h3></div>
                    </a>
                  </div>

                  <div className="social-item">
                    <a href="https://www.instagram.com/wintersix6" target="_blank" rel="noopener noreferrer" className="social-platform-link">
                      <div className="social-icon-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="custom-svg">
                          <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                        </svg>
                      </div>
                      <div className="social-info"><h3>Instagram</h3></div>
                    </a>
                  </div>

                  <div className="social-item">
                    <a href="https://www.youtube.com/@wintersix" target="_blank" rel="noopener noreferrer" className="social-platform-link">
                      <div className="social-icon-container">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="custom-svg">
                          <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                        </svg>
                      </div>
                      <div className="social-info"><h3>YouTube</h3></div>
                    </a>
                  </div>
                </div>
              </section>

              {/* ── ABOUT ── */}
              <section className="section" id="about">
                <h2>ABOUT</h2>
                <p>
                  London based DJ &amp; producer Wintersix is a rising star in the world of dance music. His unique sound, which blends progressive house, tech house and techno, has caught the attention of audiences worldwide.
                </p>
              </section>

              {/* ── NEWSLETTER ── */}
              <section className="section newsletter" id="signup">
                <h2>STAY UPDATED</h2>
                <p>Subscribe to receive updates on new music, tour dates, and exclusive content:</p>
                <NewsletterForm />
                <div className="footer">
                  <SocialLinks />
                  <div className="footer-credits">
                    <p className="design-credit">
                      Built by{" "}
                      <a href="https://matherslabs.com" target="_blank" rel="noopener noreferrer" className="wintersix-link">
                        MathersLabs
                      </a>
                    </p>
                    <p className="copyright">© {new Date().getFullYear()} Wintersix. All rights reserved.</p>
                  </div>
                </div>
              </section>

            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
